module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-movie-detail"
  }, [_c('div', {
    staticClass: "page-padding"
  }, [_c('div', {
    staticClass: "movie-detail"
  }, [_c('div', {
    staticClass: "movie-image"
  }, [_c('div', {
    staticClass: "preview-wrapper"
  }, [_c('div', {
    staticClass: "preview",
    style: ({
      backgroundImage: 'url(' + _vm.movie.imageUrl + ')'
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "movie-info"
  }, [_c('div', {
    staticClass: "movie-info-bg"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.movie.shortTitle)
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.movie.subtitle))]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("Author:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.movie.author))]), _vm._v(" "), _c('dt', [_vm._v("Kategorie:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.movie.category))]), _vm._v(" "), _c('dt', [_vm._v("Länge:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.movie.duration))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.movie.description))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "id": "i_2_0"
    },
    on: {
      "click": function($event) {
        return _vm.play()
      }
    }
  }, [_vm._v("Wiedergeben")])])])]), _vm._v(" "), _c('div', {
    staticClass: "dark-bg"
  }, [_c('h2', [_vm._v("Zuschauer sahen auch")]), _vm._v(" "), _c('most-viewed-movies-list', {
    attrs: {
      "movieid": _vm.movie.id
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7973e462","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MovieDetail.vue
// module id = 90
// module chunks = 0